import React from "react";

import useScrollToTop from "../../../hooks/useScollToTop";

import NotificationStats from "./components/NotificationStats";
import NotificationFilters from "./components/NotificationFilters";
import NotificationTable from "./components/NotificationTable";
import NotificationMobileList from "./components/NotificationMobileList";
import NotificationPagination from "./components/NotificationPagination";
import NotificationSkeleton from "./components/NotificationSkeleton";
import NotificationEmptyState from "./components/NotificationEmptyState";

import { useAdminNotifications } from "./hooks/useAdminNotifications";

function NotificationList() {
  useScrollToTop();

  const {
    filteredNotifications,
    paginatedNotifications,
    filters,
    stats,
    loading,
    refreshing,
    deletingId,
    page,
    totalPages,
    fetchNotifications,
    updateFilter,
    resetFilters,
    setPage,
    handleDeleteNotification,
  } = useAdminNotifications();

  const hasFilters = Boolean(filters.search || filters.category !== "all");

  return (
    <div className="w-full space-y-6 font-satoshi">
      {loading ? (
        <NotificationSkeleton />
      ) : (
        <>
          <NotificationStats stats={stats} />

          <NotificationFilters
            filters={filters}
            stats={stats}
            refreshing={refreshing}
            onChange={updateFilter}
            onReset={resetFilters}
            onRefresh={() => fetchNotifications({ silent: false })}
          />

          {paginatedNotifications.length > 0 ? (
            <>
              <NotificationTable
                notifications={paginatedNotifications}
                deletingId={deletingId}
                onDelete={handleDeleteNotification}
              />

              <NotificationMobileList
                notifications={paginatedNotifications}
                deletingId={deletingId}
                onDelete={handleDeleteNotification}
              />

              <NotificationPagination
                page={page}
                totalPages={totalPages}
                perPage={filters.perPage}
                totalItems={filteredNotifications.length}
                onPageChange={setPage}
                onPerPageChange={updateFilter}
              />
            </>
          ) : (
            <NotificationEmptyState
              hasFilters={hasFilters}
              onReset={resetFilters}
            />
          )}
        </>
      )}
    </div>
  );
}

export default NotificationList;